import Swiper from "swiper/bundle";

const initSwiper = (el, config) => {
  const container = el.querySelector(".js-swiper-container");

  const pageTemplate = el.querySelector(".js-swiper-page-template");
  const swiperNav = el.querySelector(".js-swiper-nav");
  const swiperPages = el.querySelector(".js-swiper-pages");

  const slideCount = +el.dataset.slideCount;

  const setupActivePage = (swiper) => {
    const pages = [...el.querySelectorAll(".js-swiper-page")];

    for (const page of pages) {
      page.classList.remove("--active");
    }

    pages[swiper.realIndex]?.classList?.add("--active");

    const visibilityItems = [
      ...el.querySelectorAll(".js-swiper-visibility-item"),
    ];

    for (const item of visibilityItems) {
      item.classList.toggle(
        "--active",
        +item.dataset.visibilityIndex == +swiper.realIndex
      );
    }
  };

  const setupPaging = (swiper) => {
    const slidePerView = swiper.params.slidesPerView;

    swiperPages.innerHTML = "";
    swiperNav.style.opacity = 0;
    swiperPages.style.opacity = 0;

    if (slideCount <= slidePerView) {
      return;
    }

    const totalPages = slideCount - slidePerView + 1;

    if (totalPages > 4) {
      swiperNav.style.opacity = 1;
      return;
    }

    let out = [];

    for (let i = 0; i < totalPages; i++) {
      out.push(pageTemplate.innerHTML);
    }

    swiperPages.innerHTML = out.join("");
    swiperPages.style.opacity = 1;
    swiperNav.style.opacity = 1;

    setupActivePage(swiper);
  };

  const swiper = new Swiper(container, {
    navigation: {
      nextEl: el.querySelector(".js-swiper-next"),
      prevEl: el.querySelector(".js-swiper-back"),
    },

    ...config,
    on: {
      resize: function (swiper) {
        //swiperResize(swiper);
        setupPaging(swiper);
      },
      init: function (swiper) {
        setupPaging(swiper);
      },
    },
  });

  swiper.on("activeIndexChange", () => {
    setupActivePage(swiper);
  });

  return swiper;
};

document.addEventListener("page:load", () => {
  document.querySelectorAll(".js-swiper[data-mode=general]").forEach((el) => {
    const swiperConfig = el.querySelector(".js-swiper-config");
    const config = JSON.parse(swiperConfig.content.textContent);
    const slideCount = +el.dataset.slideCount;
    const navContainer = el.querySelector(".js-swiper-nav-container");

    let breaksAt = undefined;

    if (config.slidesPerView >= slideCount) {
      return;
    }

    if (config.breakpoints) {
      const ordered = Object.entries(config.breakpoints).sort(
        ([_1, a], [_2, b]) => a.slidesPerView - b.slidesperView
      );
      breaksAt = ordered.find(
        ([_, value]) => value.slidesPerView >= slideCount
      )?.[0];
    }

    if (!breaksAt) {
      initSwiper(el, config);
      return;
    }

    const breakpoint = window.matchMedia(`(min-width: ${breaksAt}px)`);

    let swiper = undefined;

    const breakpointChecker = () => {
      if (!breakpoint.matches) {
        navContainer.style.removeProperty("display");
        if (!swiper) {
          swiper = initSwiper(el, config);
        }
      } else {
        navContainer.style.display = "none";
        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
      }
    };

    breakpoint.addEventListener("change", breakpointChecker);

    breakpointChecker();
  });
});
